import { HomeSectionHeader } from 'components/Header/HomeSectionHeader'
import {
  StyledHomeSection,
  StyledHomeSectionBody,
  StyledHomeSectionHeaderActionSection
} from 'components/Header/HomeSectionHeader.styled'
import { useExpand } from 'hooks/useExpand'
import { Row, Col, Collapse } from 'react-bootstrap'
import { getSaveSearchUrl } from 'utils/urlUtils'
import { SearchVin } from './SearchVin'
import { SearchSaleChannel } from './SearchSaleChannel'
import { Loader } from 'components/Loader'
import { StyledHomeSectionLink, StyleSearchGeneral } from './SearchGeneral.styled'
import { useGlobalStore } from 'store/useGlobalStore'
interface IProps {
  isFilterLoading: boolean
}
const NavigateToSaveSearch = () => {
  window.location.href = getSaveSearchUrl()
}

const RightTitle = () => {
  return (
    <StyledHomeSectionHeaderActionSection className="d-flex" onClick={NavigateToSaveSearch}>
      <StyledHomeSectionLink>My Saved Searches</StyledHomeSectionLink>
    </StyledHomeSectionHeaderActionSection>
  )
}
export const SearchGeneral = ({ isFilterLoading }: IProps) => {
  const [assetFolder] = useGlobalStore((state) => [state.userClaims.CurrentBuyerTypeAssetFolder])
  const { state: expandState, action: expandAction } = useExpand({ componentOpen: true } as never)
  const { componentOpen } = expandState
  const { setExpand } = expandAction
  return (
    <StyledHomeSection>
      <HomeSectionHeader
        sectionTitle="Search"
        onClick={() => {
          setExpand(!componentOpen)
        }}
        isExpand={componentOpen}
        leftActions={<></>}
        rightActions={RightTitle()}
      />
      <Collapse in={componentOpen}>
        <StyledHomeSectionBody>
          <StyleSearchGeneral assetFolder={assetFolder}>
            <Row>
              {isFilterLoading ? (
                <Loader overlay />
              ) : (
                <>
                  <Col xs={12} lg={6}>
                    <SearchVin loading={isFilterLoading} />
                  </Col>
                  <Col xs={12} lg={6}>
                    <SearchSaleChannel loading={isFilterLoading} />
                  </Col>
                </>
              )}
            </Row>
          </StyleSearchGeneral>
        </StyledHomeSectionBody>
      </Collapse>
    </StyledHomeSection>
  )
}
